import React from "react"
import styled from "styled-components"

import { SizeType } from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { SpacingSize } from "~/consts/style-mixins"

type TagSizeType = keyof typeof SizeType
const mapTypeToTagSize = {
  Heading: "Medium",
  SubHeading: "Small",
}

interface IProps {
  children: React.ReactNode
  type: "Heading" | "SubHeading"
  completed?: boolean
  className?: string
}
const FormHeading: React.FC<IProps> = ({ children, type, completed, className }) => (
  <StyledWrapper className={className}>
    <Typography type={type}>{children}</Typography>
    {/* NOTE:(campaign) キャンペーン時は未入力を表示しない */}
    {/* {!completed && (
      <TagWrapper>
        <Tag size={mapTypeToTagSize[type] as TagSizeType} color={Color.Attention}>
          未入力
        </Tag>
      </TagWrapper>
    )} */}
  </StyledWrapper>
)

export default FormHeading

const StyledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`
const TagWrapper = styled.span`
  display: inline-block;
  margin-left: ${SpacingSize["2XS"]}px;
`
